import { Divider } from "antd";
import styles from "./HeaderMenu.module.less";
import UserMenuItem from "./components/userMenuItem/UserMenuItem";
import NotificationMenuItem from "./components/notificationMenuItem/NotificationMenuItem";

function HeaderMenu() {
  return (
    <div className={styles.HeaderMenu}>
      <div className={styles.wrapper}>
        {/* <SettingsMenuItem />

        <Divider className={styles.m0} type="vertical" />

        <LanguageMenuItem /> */}

        <NotificationMenuItem />

        <Divider className={styles.m0} type="vertical" />

        <UserMenuItem />
      </div>
    </div>
  );
}

export default HeaderMenu;
